<template>
  <f7-block>
    <f7-block-title>{{ $t('adminDashboard.groupBuy') }}</f7-block-title>
    <div class="metric-grid">
      <div class="metric-card">
        <span class="metric-lbl">{{ $t('adminDashboard.activeGroupBuys') }}</span>
        <span class="metric-val">{{ fmt(data.activeGroupBuys) }}</span>
      </div>
      <div class="metric-card">
        <span class="metric-lbl">{{ $t('adminDashboard.totalGroupBuys') }}</span>
        <span class="metric-val">{{ fmt(data.totalGroupBuys) }}</span>
      </div>
    </div>
  </f7-block>
</template>
<script setup>
const props = defineProps({ data: { type: Object, required: true } });
function fmt(n) { return n != null ? Math.round(n).toLocaleString('fr-FR') : '-'; }
</script>
<style scoped>
.metric-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(150px, 1fr)); gap: 10px; }
.metric-card { display:flex; flex-direction:column; align-items:center; gap:4px; padding:14px 8px; border-radius:12px; background:var(--f7-list-bg-color,#f5f5f5); }
.metric-lbl { font-size:11px; color:var(--f7-on-surface-variant,#8e8e93); text-align:center; line-height:1.3; }
.metric-val { font-size:20px; font-weight:700; color:var(--f7-text-color,#333); }
</style>